import React from "react"
import MUIFormLabel from "@mui/material/FormLabel"

export type FormLabelProps =
  | ({ new?: false } & React.ComponentProps<typeof MUIFormLabel>)
  | ({ new: true } & unknown)

export const FormLabel: React.FC<FormLabelProps> = ({ ...props }) =>
  props.new ? null : <MUIFormLabel {...props} />

export default FormLabel
